// extracted by mini-css-extract-plugin
module.exports = {"Control":"css-modules_Control__Vri0h","Track":"css-modules_Track__cjpKv","Indicator":"css-modules_Indicator__pVeh5","Thumb":"css-modules_Thumb__oPG1S"};